export const EMPTY_INSTANCE_NAME = '0';
export const LAST_USED_IN_STANCE_NAME_KEY = 'vf_bifrost_last_used_in_stance_name_key';
